import React, { useEffect, useRef, useState } from "react";
import styles from "./userManagement.module.scss";
import { Add, Numbers, UploadFile } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import { getAllUser, getUserByIdResponse } from "../../store/actions";
import EditIcon from "@mui/icons-material/Edit";
import { FadeLoader } from "react-spinners";

const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "USERNAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "EMAIL ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "MOBILE NUMBER",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "ROLE",
    minWidth: 170,
    align: "center",
  },
  {
    id: 6,
    label: "USER ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 7,
    label: "STATUS",
    minWidth: 170,
    align: "center",
  },
  {
    id: 8,
    label: "ACTION",
    minWidth: 170,
    align: "center",
  },
];

const UserManagement = ({ users = [] }) => {
  // Keep filtered data in sync with Redux users and search state
  const [filteredData, setFilteredData] = useState(
    Array.isArray(users) ? users : []
  );
  const [searched, setSearched] = useState("");
  const [selected, setSelected] = useState(0);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchUsers();
  }, []);

  // When users from Redux update, refresh filteredData appropriately
  useEffect(() => {
    const base = Array.isArray(users) ? users : [];
    const searchText = (searched || "").trim().toLowerCase();
    if (!searchText) {
      setFilteredData(base);
      return;
    }

    const filtered = base.filter((item) =>
      [item?.fullName, item?.phoneNumber, item?.email, item?.role].some(
        (field) =>
          String(field || "")
            .toLowerCase()
            .includes(searchText)
      )
    );
    setFilteredData(filtered);
  }, [users]);

  const fetchUsers = () => {
    setLoading(true);
    dispatch(
      getAllUser({
        callback: {
          success: () => setLoading(false),
          failure: () => setLoading(false),
        },
      })
    );
  };

  const handleEdit = (item = {}) => {
    // Store selected user in state for EditUser page
    console.log(item, "item");
    dispatch(getUserByIdResponse(item));
    navigate("/userManagement/editUser");
  };

  const getStructuredRows = (data = []) => {
    const structuredRows = data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        item?.fullName,
        item?.email,
        item?.phoneNumber,
        item?.role,
        item?.id,
        item?.status === 1 ? (
          <Button
            variant="contained"
            className={styles.ovalButton3}
            disableRipple
            disableElevation
          >
            Active
          </Button>
        ) : (
          <Button
            variant="contained"
            className={styles.ovalButton4}
            disableRipple
            disableElevation
          >
            Inactive
          </Button>
        ),
        <div className={styles.imgtable} onClick={() => handleEdit(item)}>
          <EditIcon color="primary" />
          EDIT
        </div>,
      ],
    }));

    return structuredRows;
  };
  const getData = (input, data) => {
    // Legacy helper: keep consistent return shape and fields
    const base = Array.isArray(data) ? data : [];
    const txt = (input || "").toLowerCase();
    const dataFilter = base.filter((item) =>
      [item?.fullName, item?.phoneNumber, item?.email, item?.role].some(
        (field) =>
          String(field || "")
            .toLowerCase()
            .includes(txt)
      )
    );
    setFilteredData(dataFilter);
  };

  const handleSearch = (value) => {
    setSearched(value);

    const searchText = (value || "").trim().toLowerCase();
    if (!searchText) {
      setFilteredData(users);
      return;
    }

    const filtered = (Array.isArray(users) ? users : [])?.filter((item) =>
      [item?.fullName, item?.phoneNumber, item?.email, item?.role].some(
        (field) =>
          String(field || "")
            .toLowerCase()
            .includes(searchText)
      )
    );
    setFilteredData(filtered);
  };

  const handleSaveChanges = () => {};

  const handleNavigate = () => {
    navigate("/usermanagement/addUser");
  };

  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="USER MANAGEMENT" // or any icon/component
      />
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search customers..."
              onSearch={handleSearch} // uses the prop your component expects
            /> */}
            {/* <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
            >
              Filter
            </Button> */}
            <CustomButton
              title={"Add"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={() => handleNavigate()}
            />
          </div>
        </div>
        {loading === true ? (
          <div className={styles.loadingContainer}>
            <FadeLoader
              color={"#014751"}
              loading={loading}
              size={120}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <div className={styles.bottom}>
            <GenCustomTable
              columns={columns}
              rows={getStructuredRows(filteredData || [])}
              isExportEnabled={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    users: state?.user?.users,
  };
};

export default connect(mapStateToProps, null)(UserManagement);
